import React from 'react';
import './TagsTabele.scss';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';
import { Tag } from '../../../../types/apiGeneratedTypes';

interface IProps {
  tagData: Tag;
  onEdit: (tag: Tag) => void;
  onToggleStatus: (tag: Tag) => void;
}

const TagsTableRow: React.FC<IProps> = ({ tagData, onEdit, onToggleStatus }) => {
  const isActive = tagData.is_active !== false;

  const onOptionClick = async (_id: number, action: string) => {
    if (action === 'edit') {
      onEdit(tagData);
    }
    if (action === 'toggle') {
      onToggleStatus(tagData);
    }
  };

  return (
    <div className={`table-row recommendations-table-row tags-table-row ${!isActive ? 'is-inactive' : ''}`}>
      <div className='tag-color'>
        <span
          className='color-swatch'
          style={{ backgroundColor: tagData.color || '#000000' }}
        />
      </div>
      <div className='test-title'>{tagData.name}</div>
      <div className='test-description'>{tagData.description}</div>
      <div className='tag-status'>
        <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
          {isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            { key: 'toggle', value: isActive ? 'Deactivate' : 'Activate' },
          ]}
          id={tagData.id as number}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default TagsTableRow;
